import { ElementType } from "../dom-tools/ElementType";
import { EventSlot } from "../events/EventSlot";
import { SelectionReference } from "./SelectionReference";

export abstract class PropertyEditor<R,T>
{
  static readonly labelElement = new ElementType( "property-editor-label" );
  static readonly nameElement  = new ElementType( "property-editor-name" );
  static readonly iconElement  = new ElementType( "property-editor-icon" );
  static readonly containerElement = new ElementType( "property-editor-container" );

  private _selection:SelectionReference;
  get selection(){ return this._selection;}
  
  private _label:HTMLElement;
  get label(){ return this._label; }
  private _editor:HTMLElement;
  get editor(){ return this._editor; }


  readonly onRead = new EventSlot();
  readonly onWrite = new EventSlot();

  constructor( selection:SelectionReference )
  {
    this._selection = selection;
    this._label  = this._createLabel();
    this._editor = this._createEditor();
  } 

  private _createLabel():HTMLElement
  {
    let label = PropertyEditor.labelElement.create() as HTMLElement;
    let text  = PropertyEditor.nameElement.create();
    let icon  = PropertyEditor.iconElement.create();

    label.appendChild( icon );
    label.appendChild( text );

    text.appendChild( document.createTextNode( this._selection.key ) );

    return label;
  }
  
  get editorContainer():HTMLElement
  {
    return PropertyEditor.containerElement.create( this._editor ) as HTMLElement;
  }

  protected abstract _createEditor():HTMLElement
} 

